import Blogs from "../components/Blogs";

function BlogsPage() {
  return <Blogs />;
}
export default BlogsPage;
